module.exports = __webpack_public_path__ + "img/azw-ic.eac25852.svg";